import React from "react";

interface ITitleProps{
    title: string
}

export function Title(props: ITitleProps) {
    return <div style={{fontWeight: "900"}} className="text-center text-uppercase mb-5 font-weight-light fs-1">{props.title}</div>;
}
